import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import WifiForm from "./pages/WifiForm";
import Historique from "./pages/Historique";
import Admin from "./pages/Admin";
import { ProtectedAdmin, ProtectedUser } from "../src/components/ProtectedRoute";


function App() {
  return (
    <Router basename="/">
      <Routes>
        <Route path="/" element={<Login />} />

       {/*Only regular user can go here */}
        <Route path="/wifi-form" element={<ProtectedUser><WifiForm /></ProtectedUser>} />
        <Route path="/historique" element={<ProtectedUser><Historique /></ProtectedUser>} />

        {/*Only admin can go here */}
        <Route path="/admin" element={ <ProtectedAdmin><Admin /></ProtectedAdmin>} />
      </Routes>
    </Router>
  );
}
export default App;